const initialState = [];

const tickets = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ALL_ACTIONS":
      state = action.tickets || [];
      return state;
    default:
      return state;
  }
};

export default tickets;
